import styled from "styled-components";
import {colors, devices} from "../../../utils/styled/_variables.styled";
import {list} from "../../Richtext/Richtext.style";

const InfiosContentTeaserGrid = styled.a`
  overflow: hidden;

  ${props => props.isLinkless ? 'pointer-events: none;' : ''}
  &:hover {
    svg {
      transform: none;
    }
  }

  &.relatedcontent, &.news {
    aspect-ratio: 1/1;
    max-width: 644px !important;

    @media ${devices.tabletSmall} {
      aspect-ratio: 672/403;
      max-width: 672px !important;
    }

    @media ${devices.mobile} {
      aspect-ratio: 1/1;
      max-width: none !important;
    }
  }

  &.tabs__item {
    aspect-ratio: 1/1;
    width: 100%;
    max-width: 644px !important;

    @media ${devices.tabletLarge} {
      aspect-ratio: 324/469;
      max-width: 324px !important;
    }

    @media ${devices.mobile} {
      aspect-ratio: unset;
      max-width: none !important;
      height: 469px;
      width: calc(100vw - 48px);
    }
  }

  &.contentteaser {
    aspect-ratio: 418/592;

    @media ${devices.tabletSmall} {
      aspect-ratio: 324/469;
    }

    @media ${devices.mobile} {
      aspect-ratio: 327/462;
    }
  }

  &.bluetiles {
    aspect-ratio: 1/1;

    > div {
      background-color: ${colors.blue};
      background: ${colors.blue};
      transition: background-color 300ms ease;

      .hover__overlay {
        display: none;
      }

      &::before {
        display: none;
      }
    }

    .teaser__title, .description {
      transition: opacity 300ms ease;
      ${list}
    }

    &:hover {
      > div {
        background-color: ${props => props.linkPath ? colors.infiosGray : colors.infiosGray};
        opacity: 1;

        .teaser__title, .description {
          opacity: ${props => props.linkPath ? .64 : 1};
        }
      }
    }
  }

  &.normal {
    aspect-ratio: auto;
    overflow: visible;
    position: relative;
  }
`;

const TeaserHighlight = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding: 20px;
  background-color: ${colors.white};
  cursor: ${props => props.linkPath ? 'pointer' : 'auto'};

  .teaser__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .teaser__inner {
    z-index: 2;
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .hover__overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    background-color: ${colors.infiosGray};
    z-index: 1;
    opacity: 0;
    transition: opacity 500ms ease;
    ${props => props.isLinkless ? 'display: none;' : ''}
  }

  .teaser__highlight__header {
    display: flex;
    gap: 8px;
    align-items: flex-start;

    a {
      pointer-events: all;
    }
  }

  .teaser__tag {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }


  .teaser__highlight__bottom {
    position: relative;
    transition: transform 500ms ease;
  }

  .teaser__date {
    font-size: 10px;
    color: ${colors.white};
    font-weight: 600;
    margin-bottom: 8px;
    display: block;
    line-height: 100%;
  }

  .teaser__title {
    font-size: 24px;
    line-height: 28px;
    color: ${colors.white};
    font-weight: 600;

    @media ${devices.tabletSmall} {
      font-size: 20px;
      line-height: 24px;
    }

    @media ${devices.mobile} {
      font-size: 18px;
      line-height: 22px;
    }
  }

  .description {
    ${props => props.blueTiles ? 'display: unset;' : ''}
    color: ${colors.white};
    font-size: 19px;
    line-height: 20px;
    font-weight: 300;
    margin-top: 24px;
    a {
      display: unset;
      color: ${colors.white};
      text-decoration: underline;
      cursor: pointer;
    }
    p, a, h1, h2, h3, h4, h5, h6, span{
      color: ${colors.white};
    }
  }

  .teaser__description{
    transition: max-height 0.5s ease-in-out;
    position: relative;
    max-height: 0;
    .description{
      position: relative;
      bottom: 0;
      transition: all 0.5s ease-in;
      transform: translateY(100%);
    }
  }

  .teaser__cta {
    position: absolute;
    bottom: -100px;
    font-size: 16px;
    line-height: 100%;
    color: ${colors.white};
    opacity: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: bottom 500ms ease, opacity 300ms ease;

    ${props => props.isLinkless ? 'display: none;' : ''}
    svg {
      transition: transform 300ms ease;
    }

    &:hover {
      opacity: 0.64;

      svg {
        transform: translateX(5px);
      }
    }
  }

  &:hover {
    .hover__overlay {
      opacity: 1;
      ${props => props.isLinkless ? 'display: none;' : ''}
    }

    .teaser__highlight__bottom {
      ${props => props.isLinkless || !props.linkPath ? '' : 'transform: translateY(-45px);'}
    }

    .teaser__description{
      transition: max-height 0.5s ease-in-out;
      max-height: 1000px;
      transition-delay: unset;
      .description{
        position: relative;
        transform: translateY(0%);
        transition-delay: unset;
      }
    }

    .teaser__cta {
      bottom: 0;
    }
  }

  &:before {
    z-index: 1;
    content: "";
    background-image: ${props => {
      switch (props.shadow) {
        case 'top':
          return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
        case 'bottom':
          return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
        case 'both':
          return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
        case 'none':
          return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
        default:
          return 'linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)';
      }
    }};
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;


const TeaserNormal = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .hover__shadow {
    -webkit-box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.25);
    opacity: 0;
    transition: opacity 300ms ease;
    position: absolute;
    inset: 0;
    pointer-events: none;
  }

  .top {
      &:before {
          content: "";
          background-image: ${props => {
              switch (props.shadow) {
                  case 'top':
                      return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
                  case 'bottom':
                      return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
                  case 'both':
                      return `linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)`;
                  case 'none':
                      return `linear-gradient(0.28deg, rgba(0, 0, 0, 0) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0) 99.75%)`;
                  default:
                      return 'linear-gradient(0.28deg, rgba(0, 0, 0, 0.56) 0.25%, rgba(0, 0, 0, 0) 51.69%, rgba(0, 0, 0, 0.56) 99.75%)';
              }
          }};
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          background-size: cover;
          background-position: center;
          width: 100%;
          aspect-ratio: 418/209;
          padding: 20px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
      }
      &__bg {
        z-index: -1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    width: 100%;
    aspect-ratio: 418/209;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
  }

  .teaser__normal__header {
      display: flex;
      gap: 10px;
      align-items: center;
      z-index: 1;
  }

  .teaser__normal__content {
    padding: 20px;
    background-color: ${props => props.backgroundColor || 'transparent'};
    display: flex;
    flex-direction: column;
    flex: 1;

    .teaser__date {
      font-size: 10px;
      color: ${colors.gray5};
      font-weight: 600;
      margin-bottom: 8px;
      display: block;
      line-height: 100%;
    }

    .teaser__title {
      font-size: 24px;
      line-height: 28px;
      color: ${colors.infiosGray};
      font-weight: 600;
      margin-bottom: 16px;
      transition: color 300ms ease;

      @media ${devices.tabletSmall} {
        font-size: 20px;
        line-height: 24px;
      }

      @media ${devices.mobile} {
        font-size: 18px;
        line-height: 22px;
      }
    }

    .teaser__text {
      font-size: 14px;
      line-height: 21px;
      font-weight: 300;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 6;
      -webkit-box-orient: vertical;
    }

    .card__spacer {
      flex: 1;
    }

    .teaser__cta {
      font-size: 16px;
      line-height: 100%;
      color: ${colors.infiosGray};
      display: flex;
      align-items: center;
      gap: 10px;
      margin-top: 24px;

      svg {
        transition: transform 200ms ease;

				path {
					fill: ${colors.infiosGray};
				}
      }

      &:hover {
        svg {
          transform: translateX(5px);
        }
      }
    }
  }

  &:hover {
    .hover__shadow {
      opacity: 1;
    }

    .teaser__title {
      color: ${colors.infiosGray};
    }

    .teaser__cta {
      color: ${colors.infiosGray};
    }

    .teaser__cta svg {
      transform: translateX(5px);
    }

    .teaser__cta svg path {
      fill: ${colors.infiosGray};
    }
  }
`;

const Category = styled.span`
  font-size: 10px;
  color: ${colors.white};
  font-weight: 600;
  padding: 6px 16px;
  line-height: ${props => props.newsVersion ? '120%' : '150%'};
  background-color: rgba(255, 255, 255, .32);
  border-radius: 50px;
  transition: background-color 300ms ease;

  &:hover {
    background-color: rgba(255, 255, 255, .50);
  }

  &:first-letter {
    text-transform: uppercase;
  }
`;

const Highlight = styled.span`
  font-size: 10px;
  color: ${colors.white};
  font-weight: 600;
  padding: 2px 16px;
  background-color: ${colors.infiosGray};
  border-radius: 50px;
`;

const ReadingTime = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 3px;
  align-items: baseline;

  span {
    font-size: 10px;
    color: ${colors.white};
    font-weight: 600;
  }
`;

export {InfiosContentTeaserGrid, TeaserHighlight, TeaserNormal, Category, Highlight, ReadingTime};
